import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageIcon, MapPinIcon, HeartIcon, TicketIcon, RefreshCwIcon, WalletIcon, GiftIcon, FileTextIcon } from 'lucide-react';
export function QuickActionsGrid() {
  const navigate = useNavigate();
  const actions = [{
    icon: PackageIcon,
    label: 'Orders',
    count: 5,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    badgeColor: 'bg-purple-500',
    path: '/account/orders'
  }, {
    icon: HeartIcon,
    label: 'Wishlist',
    count: 12,
    color: 'text-rose-600',
    bgColor: 'bg-rose-50',
    badgeColor: 'bg-rose-500',
    path: '/account/wishlist'
  }, {
    icon: TicketIcon,
    label: 'Coupons',
    count: 3,
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    badgeColor: 'bg-emerald-500',
    path: '/account/coupons'
  }, {
    icon: MapPinIcon,
    label: 'Addresses',
    count: 2,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    badgeColor: 'bg-blue-500',
    path: '/account/addresses'
  }, {
    icon: RefreshCwIcon,
    label: 'Returns',
    count: 0,
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
    badgeColor: 'bg-orange-500',
    path: '/account/returns'
  }, {
    icon: WalletIcon,
    label: 'Wallet',
    count: 0,
    color: 'text-teal-600',
    bgColor: 'bg-teal-50',
    badgeColor: 'bg-teal-500',
    path: '/account/wallet'
  }, {
    icon: GiftIcon,
    label: 'Rabeh Rewards',
    count: 0,
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
    badgeColor: 'bg-amber-500',
    path: '/account/points'
  }, {
    icon: FileTextIcon,
    label: 'Prescriptions',
    count: 0,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    badgeColor: 'bg-indigo-500',
    path: '/prescription/history'
  }];
  return <div className="px-4 mt-4" data-id="element-1089" data-mp="3kr2wy97xfu0i">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3" data-id="element-1090" data-mp="2v4s5gywcwlv1">
        <div className="flex items-center justify-between px-1 pb-2" data-id="element-1091" data-mp="2q68dagr66du8">
          <h3 className="text-sm font-bold text-gray-900" data-id="element-1092" data-mp="2q442deuusekg">Quick Actions</h3>
        </div>
        <div className="grid grid-cols-4 gap-y-3" data-id="element-1093" data-mp="34wfp4dmo8yly">
          {actions.map((action, index) => {
          const Icon = action.icon;
          return <button key={index} onClick={() => navigate(action.path)} className="relative flex flex-col items-center gap-1.5 p-2 rounded-xl active:scale-95 active:bg-gray-50 transition-transform" data-id="element-1094" data-mp="3dv9qehay6d5u" data-mpi={index}>
                {action.count > 0 && <div className={`absolute top-0 right-2 ${action.badgeColor} text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 ring-2 ring-white`} data-id="element-1095" data-mp="3iumh5d4xw4dp">
                    {action.count}
                  </div>}
                <div className={`w-11 h-11 ${action.bgColor} rounded-xl flex items-center justify-center`} data-id="element-1096" data-mp="4058rhtptx0p">
                  <Icon className={`w-5 h-5 ${action.color}`} data-id="element-1097" data-mp="3qeewdoptn10f" />
                </div>
                <span className="text-[11px] font-medium text-gray-700 text-center leading-tight" data-id="element-1098" data-mp="3qcau1b7kma29">
                  {action.label}
                </span>
              </button>;
        })}
        </div>
      </div>
    </div>;
}